import { Attachment } from './types';
import { globalGetService } from '@/utils/globalApiServices';

export const getCampaignAttachments = async (
  campaignUid: string,
  folder: string
) => {
  const response = await globalGetService(
    `mno/attachments/campaign/${campaignUid}?folder=${encodeURIComponent(
      folder
    )}`
  );
  return (response?.ok ? response.data : []) as Attachment[];
};

export const download = async (
  attachmentUuid: string,
  fileProps: { filename: string }
) => {
  const { filename } = fileProps;
  const response = await globalGetService(
    `mno/attachments/download?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`,
    {},
    { responseType: 'arraybuffer' }
  );
  return response?.ok
    ? {
        file: new File([response.data as ArrayBuffer], filename, {
          type: (response.headers['content-type'] ||
            'application/octet-stream') as string,
        }),
      }
    : undefined;
};
